import * as Traits from '@web/features/collection/traits/type';
import { Trait } from '@web/features/collection/traits/type';

import rawData from './data.json';

interface ITraits {
  [Trait.BACKGROUND]: Traits.Background;
  [Trait.AURA]: Traits.Aura;
  [Trait.BACK]: Traits.Back;
  [Trait.CLOTHING]: Traits.Clothing;
  [Trait.COUNCIL]: Traits.Council;
  [Trait.EARRINGS]: Traits.Earrings;
  [Trait.EYES]: Traits.Eyes;
  [Trait.EYEWEAR]: Traits.Eyewear;
  [Trait.FACE]: Traits.Face;
  [Trait.FRIENDS]: Traits.Friends;
  [Trait.HAIRCUTS]: Traits.Haircuts;
  [Trait.HEADWEARS]: Traits.Headwears;
  [Trait.MOUTH]: Traits.Mouth;
  [Trait.NECK]: Traits.Neck;
  [Trait.TYPE]: Traits.Type;
  [Trait.GENDER]: Traits.Gender;
}

export interface INftData {
  id: number;
  rank: number;
  traits: ITraits;
}

export const nftsData = rawData as INftData[];
